import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({

    st0: {
        fill: '#3A1860',
    },

    // st1: {
    //     fill: '#0078FF',
    // },

    st2: {
        fill: '#F28C00',
    },

    st3: {
        fill: '#EE7624',
    },

    st4: {
        fill: '#009BE0',
    },

    st5: {
        fill: '#01BFD7',
    },

    st6: {
        fill: '#F9BF01',
    },

    st7: {
        fill: '#76BD22',
    },

    st8: {
        fill: '#00A8E2',
    },

}));
